import React from "react";
import { baseurImage } from "../../Baseurl";
import { isAdmin } from "../../utils/permissions";

const FileUploads = ({
  radiology,
  xrayRadio,
  isEditingXray,
  dataxray,
  handlechangeXray,
  closexray,
  updateXray,
  Addreport,
  openxray,
  handleEditXray,
  openEditIxrayradio,
  uploadTypes = [],
}) => {
  const validFiles = Array.isArray(radiology) ? radiology.filter((f) => f.title) : [];
  const knownNames = new Set(uploadTypes.map((t) => t.name));
  const groups = uploadTypes
    .map((t) => ({ key: t.name, label: t.name, files: validFiles.filter((f) => f.title === t.name) }))
    .filter((g) => g.files.length > 0);
  const othersFiles = validFiles.filter((f) => !knownNames.has(f.title));
  if (othersFiles.length > 0) {
    groups.push({ key: "__others__", label: "Others", files: othersFiles });
  }

  const renderFileCard = (plan, index) => {
    const fileName = plan.attachment || "";
    const ext = fileName.split(".").pop()?.toLowerCase();
    const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(ext);
    const isPdf = ext === "pdf";
    const fileUrl = `${baseurImage}${plan.attachment}`;
    return (
      <div className="col-xl-3 col-lg-4 col-md-6 col-12" key={plan.id || index}>
        <div className="card h-100 shadow-sm border" style={{ borderRadius: "12px", overflow: "hidden" }}>
          {/* Preview Area */}
          <div
            style={{
              height: "160px",
              background: isImage ? "#f8f9fa" : "#eef2ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {isImage ? (
              <img
                src={fileUrl}
                alt={plan.title}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
            ) : null}
            <div
              style={{
                display: isImage ? "none" : "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {isPdf ? (
                <i className="fas fa-file-pdf" style={{ fontSize: "52px", color: "#e74c3c" }}></i>
              ) : ["doc", "docx"].includes(ext) ? (
                <i className="fas fa-file-word" style={{ fontSize: "52px", color: "#2980b9" }}></i>
              ) : ["xls", "xlsx"].includes(ext) ? (
                <i className="fas fa-file-excel" style={{ fontSize: "52px", color: "#27ae60" }}></i>
              ) : (
                <i className="fas fa-file-alt" style={{ fontSize: "52px", color: "#7f8c8d" }}></i>
              )}
              <span style={{ fontSize: "11px", marginTop: "6px", color: "#666", textTransform: "uppercase", fontWeight: 600 }}>{ext || "file"}</span>
            </div>
          </div>
          {/* Card Body */}
          <div className="card-body p-3">
            <h6 className="mb-1 text-truncate" title={plan.title} style={{ fontWeight: 600 }}>{plan.title}</h6>
            {plan.description && (
              <p className="text-muted mb-1 text-truncate" style={{ fontSize: "12px" }} title={plan.description}>{plan.description}</p>
            )}
            <p className="text-muted mb-0" style={{ fontSize: "11px" }}>
              <i className="ti ti-calendar me-1"></i>
              {new Date(plan.created_at).toLocaleDateString("en-GB")}
            </p>
          </div>
          {/* Actions */}
          <div className="card-footer bg-white p-2 d-flex justify-content-end gap-2" style={{ borderTop: "1px solid #f0f0f0" }}>
            <a
              href={fileUrl}
              target="_blank"
              rel="noreferrer"
              className="avtar avtar-xs btn-link-secondary viewIcon"
              title="View"
            >
              <i className="ti ti-eye f-20"></i>
            </a>
            <a
              href={fileUrl}
              download
              className="avtar avtar-xs btn-link-secondary"
              title="Download"
              style={{ color: "#4CAF50" }}
            >
              <i className="ti ti-download f-20"></i>
            </a>
            <button
              type="button"
              onClick={() => handleEditXray(plan)}
              className="avtar avtar-xs btn-link-secondary viewIcon"
              title="Edit"
            >
              <i className="ti ti-edit f-20"></i>
            </button>
            {isAdmin() && (
              <button
                type="button"
                onClick={() => openEditIxrayradio(plan)}
                className="avtar avtar-xs btn-link-secondary deleteIcon"
                title="Delete"
              >
                <i className="ti ti-trash f-20"></i>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {xrayRadio && (
        <div
          className="modal fade show"
          style={{ backgroundColor: "rgba(81, 81, 81, 0.5)", display: "block" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditingXray ? "Edit File" : "Add File"}
                </h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">
                      Title<span className="text-danger">*</span>
                    </label>
                    <select
                      name="Title"
                      value={dataxray.Title || ""}
                      onChange={handlechangeXray}
                      className="form-control"
                    >
                      <option value="">Select Title</option>
                      {dataxray.Title && !uploadTypes.some((t) => t.name === dataxray.Title) && (
                        <option value={dataxray.Title}>{dataxray.Title}</option>
                      )}
                      {uploadTypes.map((t) => (
                        <option key={t.id} value={t.name}>
                          {t.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Upload File</label>
                    <input
                      type="file"
                      name="attachment"
                      onChange={handlechangeXray}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      name="description"
                      placeholder="Description"
                      value={dataxray.description}
                      onChange={handlechangeXray}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-end">
                <button type="button" className="cancelText" onClick={closexray}>
                  Cancel
                </button>
                {isEditingXray ? (
                  <button type="button" className="bgBtn btn-sm" onClick={updateXray}>
                    Update
                  </button>
                ) : (
                  <button type="button" className="bgBtn btn-sm" onClick={Addreport}>
                    Add
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="card mb-0 border-0">
        <div className="card-header d-flex align-items-center justify-content-between py-3">
          <h5 className="mb-0">Files &amp; Images</h5>
          <button type="button" className="bgBtn btn-sm" onClick={openxray}>
            <i className="ti ti-plus me-1"></i> Add File
          </button>
        </div>
        <div className="card-body">
          {validFiles.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <i className="fas fa-folder-open" style={{ fontSize: "48px", opacity: 0.3 }}></i>
              <p className="mt-2">No files uploaded yet</p>
            </div>
          ) : (
            groups.map((group) => (
              <div key={group.key} className="mb-4">
                <h6 className="mb-3" style={{ fontWeight: 700, color: "#495057", borderBottom: "1px solid #f0f0f0", paddingBottom: 8 }}>
                  {group.label}
                  <span className="text-muted ms-2" style={{ fontWeight: 400, fontSize: "12px" }}>
                    ({group.files.length})
                  </span>
                </h6>
                <div className="row g-3">
                  {group.files.map((plan, index) => renderFileCard(plan, index))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default FileUploads;
